@if (!shareDataService.isMobileMode()) {
  <div class="user-details-wrap cursor-pointer d-flex align-items-center justify-content-between flex-lg-row flex-column">
    <div>@for (field of userDetailsFields(); track field) {
      <div  class="user-details icon-text {{field}}">{{user[field]}}</div>
    }</div>
    <i class="fa fa-angle-down mx-1"></i>
  </div>
} @else {
  <div class="user-details-wrap cursor-pointer d-flex align-items-center justify-content-between flex-lg-row flex-column">
    <div class="mobile-user-details d-flex">
      <i class="fa-regular fa-user mx-2"></i>
      <div>@for (field of userDetailsFields(); track field) {
        <div  class="user-details icon-text {{field}}">{{user[field]}}</div>
      }</div>
      <i class="fa fa-angle-down mx-1"></i>
    </div>
  </div>
}

